module.exports = __webpack_public_path__ + "img/code_bg.b006141b.png";